import { DatePipe } from '@angular/common';
import { Directive, EventEmitter, ElementRef, Renderer2, HostListener, Input, Output } from '@angular/core';

// import {setProperty} from 'angular2/ts/src/core/forms/directives/shared';
function setProperty(renderer: Renderer2, elementRef: ElementRef, propName: string, propValue: any): void {
  renderer.setProperty(elementRef, propName, propValue);
}

@Directive({ selector: '[ngTableFiltering]' })
export class NgTableFilteringDirective {

  constructor(
    private element: ElementRef, 
    private renderer: Renderer2,
    private datePipe: DatePipe) {
    
    setProperty(this.renderer, this.element, 'value', this.filtering.filterString);
  }

  @Input('ngTableFiltering') filtering: any = {
    filterString: '',
    columnName: 'name'
  }

  @Output() 
  public tableChanged: EventEmitter<any> = new EventEmitter();

  @Input()
  public get config(): any {
    return this.filtering;
  }

  public set config(value: any) {
    this.filtering = value;
    setTimeout(() => {
      if (this.filtering.filterString) {
        if (this.filtering.filterType === 'daterange') {
          let from = this.datePipe.transform(new Date(this.filtering.filterString[0]), 'MM/dd/yyyy');
          let to = this.datePipe.transform(new Date(this.filtering.filterString[1]), 'MM/dd/yyyy');
          this.renderer.setProperty(this.element.nativeElement, 'value', `${from} - ${to}`);
        } else {
          this.renderer.setProperty(this.element.nativeElement, 'value', this.filtering.filterString);
        }
      }
    }, 1);
  }

  private msInDay = 86400000;
  private timezoneOffset = new Date().getTimezoneOffset() * 60000;

  private onChangeFilter(event: any): void {
    this.filtering.filterString = event;
    this.tableChanged.emit({ filtering: this.filtering });
  }

  @HostListener('input', ['$event'])
  public onChangeInputFilter(event: any): void {
    this.onChangeFilter((event.target) ? event.target.value : '');
  }

  @HostListener('change', ['$event'])
  public onChangeSelectFilter(event: any): void {
    this.onChangeFilter((event.target) ? event.target.value : '');
  }

  @HostListener('bsValueChange', ['$event'])
  public onChangeDateFilter(event: any): void {
    let range: any;
    if (event) {
      range = event.map(d => {
        const ms = (new Date(d)).valueOf();
        const timeOnly = ms % this.msInDay;
        return ms - timeOnly + this.timezoneOffset;
      });
      range[1] += this.msInDay;
    } else {
      range = '';
    }
    this.onChangeFilter(range);
  }
}



/** WEBPACK FOOTER **
 ** ./components/table/ng-table-filtering.directive.ts
 **/